import { usePermission } from '@juvare/contact-management/ui/hooks';
export const useAdditionalSteps = () => {
    const { requireAnySystemPermission } = usePermission();
    const sharingOptions = requireAnySystemPermission('allow-create-public-mission')
        ? [
            {
                icon: 'material-groups',
                type: 'public',
                label: 'Public (Everyone)',
                description: 'Your mission will be launched for public. Click Launch & add shift to finish the step.',
            },
        ]
        : [];
    sharingOptions.push({
        icon: 'material-group-add',
        type: 'organizations',
        label: 'Specific Organization',
        description: 'Your mission will be launched for Specific Organization above. Click Launch & add shift to finish the step.',
    });
    return [
        {
            label: 'Volunteers',
            description: 'Who is the mission intended for?',
            form: {
                type: 'form',
                children: [
                    {
                        type: 'contactManagement.organizationSharing',
                        key: 'organizationSharing',
                        disableNotVisible: true,
                        includeByOrgPermission: ['manage-organization'],
                        validate: {
                            required: true,
                            minOrganizationsLength: 1,
                        },
                        sharingOptions,
                        minOrganizationsLength: 1,
                    },
                ],
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        },
    ];
};
